import { useEffect } from 'react';
import { useEffectEvent } from '../hooks/useEffectEvent';

type RefType<T> = React.RefObject<T>;

export const useClickOutside = <T extends HTMLElement, T2 extends HTMLElement>(
  ref: RefType<T>,
  controlRef: RefType<T2>,
  state: boolean,
  setState: (state: boolean) => void,
) => {
  const handleClickOutside = useEffectEvent((event: MouseEvent) => {
    if (
      state &&
      (!ref.current || !ref.current.contains(event.target as Node)) &&
      (!controlRef.current ||
        !controlRef.current.contains(event.target as Node))
    ) {
      setState(false);
    }
  });

  useEffect(() => {
    if (!state) return;

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [state, handleClickOutside]);
};
